import { ApiProperty } from "@nestjs/swagger";

export class ItemForBrandReq{
    @ApiProperty()
    brandId?:number;
    @ApiProperty()
    itemSubCategoryId:number
    @ApiProperty()
    saleOrderId:number
}